import { BaseParser, DATA_TYPE_PLOTLY, TYPE_PLOTLY } from './baseExtractor';

const iconHTML = 'htmlFile.png';
const notifyZone = 'HTML File Extraction';

class HTMLExtractor extends BaseParser {
    separateLinesFile(data) {
      let dataSplit = data.replaceAll('\n', '').split('\r');
      if (dataSplit.length > 1) {
        return dataSplit;
      }
      dataSplit = data.replaceAll('\r', '').split('\n');
      if (dataSplit.length > 1) {
        return dataSplit;
      }
    
      dataSplit = data.replaceAll(String.fromCharCode(13), '').split(String.fromCharCode(10));
      if (dataSplit.length > 1) {
        return dataSplit;
      }
      dataSplit = data.replaceAll(String.fromCharCode(10), '').split(String.fromCharCode(13));
      if (dataSplit.length > 1) {
        return dataSplit;
      }
      return null;
    }

    
    // eslint-disable-next-line no-unused-vars
    async _doParse(parent, fileName, data, report) {
      const returnValue = this.getNewReturnValue();
      const rePlotlyText = RegExp('Plotly\\.newPlot\\(');
      const dataSplit = this.separateLinesFile(data);
      if (dataSplit === null) {
        returnValue.lastError = `Error the file "${fileName}" has a incorrect format, cannot separate the lines.`;
        return returnValue;
      }
      let dataPlotly = null;
      let layotPlotly = null;
      for (let j = 0; j < dataSplit.length; j++) {
        const line = dataSplit[j];
        const matchLine = rePlotlyText.exec(line);
        if (matchLine) {
          if (dataPlotly !== null) {
            const warnText = 'More than one plotly graph in the html file.';
            const warnTitle = 'No supported yet';
            if (parent && parent.$notifTerm && typeof parent.$notifTerm.addNotification === 'function') {
              parent.$notifTerm.addNotification(parent.$notifTerm.typesNotif.ERROR, warnTitle, warnText, notifyZone);
            } else {
              returnValue.warnings.push(`${warnTitle}: ${warnText}`);
            }
          }
          //Counter to find the scope of the function
          let countBrackets = 1;
          const startSubStr = matchLine.index + 15;
          let endSubStr;
          //Counter to find the arguments of the function
          let innerCountSections = 0;
          let startSection = startSubStr;
          const sections = [];
          //Start the for loop just after the match. Verify whethe function is closed
          for (endSubStr = startSubStr; endSubStr < line.length; endSubStr++) {
            const charAt = line.charAt(endSubStr);
            if (charAt === '(') {
              countBrackets++;
              innerCountSections++;
            } else if (charAt === ')') {
              countBrackets--;
              innerCountSections--;
            } else if (charAt === '{' || charAt === '[') {
              innerCountSections++;
            } else if (charAt === '}' || charAt === ']') {
              innerCountSections--;
            }
            if (innerCountSections === 0 && charAt === ',') {
              sections.push(line.substring(startSection, endSubStr));
              startSection = endSubStr + 1;
            }
            if (countBrackets === 0) {
              sections.push(line.substring(startSection, endSubStr));
              break;
            }
          }
          //If we reached the end of line then the format is not supported or the line was a definition in the html
          if (endSubStr === line.length) {
            continue;
          }
          if (sections[1].search('\\[') === -1) {
            continue;
          }
          try {
            dataPlotly = JSON.parse(`{"data":${sections[1]}}`).data;
            layotPlotly = JSON.parse(`{"data":${sections[2]}}`).data;
          } catch (e) {
            dataPlotly = null;
            layotPlotly = null;
            continue;
          }
        }
      }
      returnValue.processedData = dataPlotly !== null ? { data: dataPlotly, layout: layotPlotly } : {};
      returnValue.lastError = dataPlotly === null ? `File '${fileName}' does not contain processable information` : '';
      returnValue.dataType = DATA_TYPE_PLOTLY;
      returnValue.type = TYPE_PLOTLY;
      returnValue.icon = iconHTML;
      returnValue.success = dataPlotly !== null;
      return returnValue;
  }
}

export{
  HTMLExtractor,
};
